import { Component } from '@angular/core';

@Component({
    template: `
        Favorite places, spaces, controls, and graphs can be pinned/unpinned to home by
        clicking the favorite button <mat-icon color="primary">star</mat-icon> in the top app bar in each area.
  `
})
export class FavoritesInstructionMessageComponent {
}
